import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import "./PisteContent.scss";
// function wrapTables(content) {
//   return content?.replace(
//     /<table.*?<\/table>/gi,
//     '<div class="table-wrapper">$&</div>'
//   );
// }
var preventScrollbarsOnWindows = {
    overflowX: "hidden"
};
var PisteItem = function(param) {
    var content = param.content;
    // const html = wrapTables(content);
    return /*#__PURE__*/ _jsx("div", {
        style: preventScrollbarsOnWindows,
        className: "piste-content",
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
};
PisteItem.propTypes = {
    content: PropTypes.string
};
export default PisteItem;
